import { render, staticRenderFns } from "./CategoryProductForm.vue?vue&type=template&id=3f4f4aa1"
import script from "./CategoryProductForm.vue?vue&type=script&lang=js"
export * from "./CategoryProductForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports